import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Icon, Grid, Header } from 'semantic-ui-react';
import { useCanViewVideoLibrary } from '../auth';
import './DocumentsHub.css';

const HubCard = ({ header, icon, description, href }) => {
    const navigate = useNavigate();
    return (
        <Card
            fluid
            className="hub-card"
            onClick={() => navigate(href)}
            header={
                <div className="hub-card-header">
                    <div>{header}</div>
                    <Icon color="grey" name={icon} />
                </div>
            }
            description={description}
        />
    );
};

export const DocumentsHub = () => {
    const canViewVideoLibrary = useCanViewVideoLibrary();

    return (
        <div className="homepage">
            <Header as="h2">Documents</Header>
            <Grid className="documents-grid" stackable>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <HubCard
                            header="Documents"
                            icon="file alternate outline"
                            href="/documents/list"
                            description="View, upload and manage PDF and DOCX documents."
                        />
                    </Grid.Column>
                    {canViewVideoLibrary && (
                    <Grid.Column width={8}>
                        <HubCard
                            header="Video Content"
                            icon="film"
                            href="/documents/video-content"
                            description="Browse and manage training and reference video content."
                        />
                    </Grid.Column>
                    )}
                    {
                    <Grid.Column width={8}>
                        <HubCard
                            header="Form Checklists"
                            icon="file alternate outline"
                            href="/documents/form-checklists"
                            description="Create, view, and manage form checklists (To-Do List)."
                        />
                    </Grid.Column>
                    }
                </Grid.Row>
            </Grid>
        </div>
    );
};
